import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  FormGroup,
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import CustomSelect from "components/Common/custom-select";
import TableContainer from "components/Common/TableContainer";
import CustomDatePicker from "common/CustomDatePicker";
import { useFormik } from "formik";
import * as Yup from "yup";
import Loader from "common/pageLoader";
import { exportEmployeeToExcel } from "pages/exports/exportExcel";
import { exportEmployeeToPDF } from "pages/exports/exportPDF";
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { fetchCategories, fetchDepartments, fetchDesignations, fetchEmployeeDropdownAutoList, fetchExtraHoursReport, resetAttendanceReport } from "store/actions";
import CustomMonthPicker from "common/CustomMonthPicker";

const statusOptions = [
  { label: "Pending", value: 1},
  { label: "Approved", value: 2 },
  { label: "Rejected", value: 3 },
];

const AttendanceReportOTHours = () => {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
      const rights = getAccessRights(location.pathname, history);
      setAccessRight(rights?.data);
  }, [location]);
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prev) => !prev);
  const {
    employeeReport,
    categories,
    departments,
    dropdownAutoList,
    designations,
    loading,
    error,
    success
  } = useSelector((state) => ({
    employeeReport: state.AttendanceReportReducer?.employeeReport ?? [],
    categories: state.CategoryMaster?.categories ?? [],
    departments: state.DepartmentMaster?.departments ?? [],
    dropdownAutoList: state.EmployeeDetailsReducer?.dropdownAutoList ?? [],
    designations: state.DesignationMaster?.designations ?? [],

    loading: state.AttendanceReportReducer?.loading,
    error: state.AttendanceReportReducer?.error,
    success: state.AttendanceReportReducer?.success,
  }));

  useEffect(() => {
    dispatch(resetAttendanceReport())
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchCategories(unitId));
    dispatch(fetchDepartments(unitId));
    dispatch(fetchEmployeeDropdownAutoList(unitId))
    dispatch(fetchDesignations(unitId));
  }, [dispatch]);

  const formik = useFormik({
    initialValues: {
      category: "",
      department: "",
      designation: "",
      reportType: "Bank Hours", 
      employee:"",
      month: new Date(new Date().setMonth(new Date().getMonth() - 1)),
      status: "",
    },
    validationSchema: Yup.object({
      reportType: Yup.string().required("Report type is required"),
      month: Yup.string().nullable().required("Month is required"),
      status: Yup.string().required("Status is required"),
    }),
    onSubmit: (values) => {
      // console.log("Search values:", values);
      const formData = new FormData();
      formData.append("dep_id", values.department || 0);
      formData.append("design_id", values.designation || 0);
      formData.append("cat_id", values.category || 0);
      formData.append("emp_code", values.employee || 0);
      formData.append("status", values.status);
      formData.append("month", values.month);
      formData.append("report_type", values.reportType === "Bank Hours" ? 1 : 2);
      formData.append("unit_id", authDetails?.unit_id);
      dispatch(fetchExtraHoursReport(formData))
    },
  });

  const columns2 = [
    { Header: "S No", Cell: ({ row }) => employeeReport.length - row.index, className: "serial-no text-center", },
    { Header: "Code", accessor: "emp_id" },
    { Header: "Name", accessor: "emp_name" },
    { Header: "Category", accessor: "category" },
    { Header: "Department", accessor: "department" },
    { Header: "Designation", accessor: "designation" },
    { Header: "Month", accessor: "month" },
    { Header: "Available Hours", accessor: "availabled_hours" },
    { Header: "Approved Hours", accessor: "approved_hours" },
    { Header: "Amount", accessor: "amount" },
    { Header: "Status", accessor: "status" },
    { Header: "Approved By", accessor: "approved_by" },
    { Header: "Approved On", accessor: "approved_on" },
    { Header: "Approved Remarks", accessor: "approved_remarks" },
    // { Header: "Cancelled By", accessor: "cancelledBy" },
    // { Header: "Cancelled On", accessor: "cancelledOn" },
    // { Header: "Cancelled Remarks", accessor: "cancelledRemarks" },
  ];

  const columns = [
    {
      Header: "S.No",
      Cell: ({ row }) => employeeReport.length - row.index,
      className: "serial-no text-center",
    },
    { Header: "Code", accessor: "emp_id" },
    { Header: "Name", accessor: "emp_name" },
    { Header: "Category", accessor: "category" },
    { Header: "Department", accessor: "department" },
    { Header: "Designation", accessor: "designation" },
    { Header: "Date", accessor: "date" },
    { Header: "From Time", accessor: "from_time" },
    { Header: "To Time", accessor: "to_time" },
    { Header: "Claimed Hours", accessor: "claimed_hours" },
    { Header: "Approved Hours", accessor: "approved_hours" },
    { Header: "Status", accessor: "status" },
    { Header: "Claimed By", accessor: "claimed_by" },
    { Header: "Claimed On", accessor: "claimed_on" },
    { Header: "Claimed Reason", accessor: "claimed_reason" },
    { Header: "Approved By", accessor: "approved_by" },
    { Header: "Approved On", accessor: "approved_on" },
    { Header: "Approved Remarks", accessor: "approved_remarks" },
    { Header: "Rejected By", accessor: "rejected_by" },
    { Header: "Rejected On", accessor: "rejected_on" },
    { Header: "Rejected Remarks", accessor: "rejected_remarks" },
    // { Header: "Cancelled By", accessor: "cancelledBy" },
    // { Header: "Cancelled On", accessor: "cancelledOn" },
    // { Header: "Cancelled Remarks", accessor: "cancelledRemarks" },
  ];

  
  const activeColumns =
    formik.values.reportType === "Bank Hours" ? columns : columns2;

  const handleReset = () => {
      formik.resetForm(); 
      dispatch(resetAttendanceReport()); 
  };

  return (
    <div className="page-content">
      <Loader loading={loading}/>
      <Container fluid>
        <Breadcrumbs title="Attendance" breadcrumbItem="Extra Hours" />
        <Card>
          <CardBody>
            <form onSubmit={formik.handleSubmit}>
              <Row className="gy-3">
                <Col md={3}>
                    <Label>Category</Label>
                    <CustomSelect
                      id="category"
                      name="category"
                      options={categories.map(cat => ({ value: cat.empCatgryid, label: cat.empCategory }))}
                      value={
                        categories
                          .map(cat => ({ value: cat.empCatgryid, label: cat.empCategory }))
                          .find(cat => cat.value === formik.values.category) || null
                      }
                      onChange={val => formik.setFieldValue('category', val ? val.value : '')}
                      onBlur={formik.handleBlur}
                      className={`select-dropdown ${formik.touched.category && formik.errors.category ? 'is-invalid' : ''}`}
                    />
                  </Col>                

                  <Col md={3}>
                    <Label>Department</Label>
                    <CustomSelect
                        id="department"
                        name="department"
                        options={departments.map(dept => ({ value: dept.departmentId, label: dept.departmentname }))}
                        value={
                          departments
                            .map(dept => ({ value: dept.departmentId, label: dept.departmentname }))
                            .find(dept => dept.value === formik.values.department) || null
                        }
                        onChange={val => formik.setFieldValue('department', val ? val.value : '')}
                        onBlur={formik.handleBlur}
                        className={`select-dropdown ${formik.touched.department && formik.errors.department ? 'is-invalid' : ''}`}
                      />
                  </Col>

                  <Col md={3}>
                    <Label>Designation</Label>
                    <CustomSelect
                        id="designation"
                        name="designation"
                        options={designations.map(des => ({ value: des.desig_id, label: des.designation }))}
                        value={
                          designations
                            .map(des => ({ value: des.desig_id, label: des.designation }))
                            .find(des => des.value === formik.values.designation) || null
                        }
                        onChange={(val) => formik.setFieldValue("designation", val ? val.value : "")}
                        onBlur={formik.handleBlur}
                        className={`select-dropdown ${
                          formik.touched.designation && formik.errors.designation ? "is-invalid" : ""
                        }`}
                      />
                  </Col>
                  <Col md={3}>
                    <Label>
                      Employee
                    </Label>
                    <CustomSelect
                        id="employee"
                        name="employee"
                        options={dropdownAutoList.map(emp => ({
                          value: String(emp.emp_id),
                          label: emp.emp_no
                        }))}

                        // UI needs the object, so find matching option
                        value={
                          dropdownAutoList
                            .map(emp => ({
                              value: String(emp.emp_id),
                              label: emp.emp_no
                            }))
                            .find(option => option.value === formik.values.employee) || null
                        }

                        // Form Data: store string only
                        onChange={(selected) =>
                          formik.setFieldValue("employee", selected ? selected.value : "")
                        }
                      />
                      {formik.touched.employee && formik.errors.employee && (
                        <div className="text-danger">
                          {formik.errors.employee}
                        </div>
                      )}
                  </Col>

                  <Col md={3}>
                    <Label>Status <span className="text-danger">*</span></Label>
                    <CustomSelect
                      id="eh_status"
                      name="eh_status"
                      options={statusOptions.map(stat => ({ value: stat.value, label: stat.label }))} 
                      value={
                        statusOptions
                          .map(stat => ({ value: stat.value, label: stat.label }))
                          .find(stat => stat.value === formik.values.status) || null
                      }
                      onChange={val => formik.setFieldValue("status", val ? val.value : "")}
                      onBlur={formik.handleBlur}
                      className={`select-dropdown ${
                        formik.touched.status && formik.errors.status ? "is-invalid" : ""
                      }`}
                    />
                    {formik.touched.status && formik.errors.status && (
                      <div className="text-danger">{formik.errors.status}</div>
                    )}
                  </Col>

                  <Col md={3} >
                      <FormGroup>
                        <Label for="month">
                          Month <span className="text-danger">*</span>
                        </Label>

                        <CustomMonthPicker
                          name="month"
                          value={formik.values.month}
                          onChange={(val) => formik.setFieldValue("month", val)}
                          onBlur={formik.handleBlur}
                          disableFuture={true}
                          className={`form-control ${formik.touched.month && formik.errors.month ? "is-invalid" : ""}`}
                        />

                        {formik.touched.month && formik.errors.month && (
                          <div className="text-danger">{formik.errors.month}</div>
                        )}
                      </FormGroup>
                </Col>

                  <Col md={3}>
                    <Label></Label>
                    <div className="d-flex align-items-center gap-4 mt-2">

                      <Label className="mb-0">
                        <Input
                          type="radio"
                          name="reportType"
                          value="Bank Hours"
                          checked={formik.values.reportType === "Bank Hours"}
                          onChange={(e) => {
                            formik.handleChange(e);
                            dispatch(resetAttendanceReport());
                          }}
                        />{" "}
                        Bank Hours
                      </Label>

                      <Label className="mb-0">
                        <Input
                          type="radio"
                          name="reportType"
                          value="Payment"
                          checked={formik.values.reportType === "Payment"}
                          onChange={(e) => {
                            formik.handleChange(e);
                            dispatch(resetAttendanceReport());
                          }}
                        />{" "}
                        Payment
                      </Label>

                    </div>

                    {formik.touched.reportType && formik.errors.reportType && (
                      <div className="text-danger">{formik.errors.reportType}</div>
                    )}
                  </Col>

                <Col className="d-flex mob-center align-items-center justify-content-end">
                  <Button type="submit" className="btn button-search me-2 mt-2">
                    <i className="fas fa-search me-1" /> Search
                  </Button>
                  <Button type="button" className="btn button-cancel me-2 mt-2" onClick={handleReset}>
                    <i className="fas fa-sync me-1" /> Cancel
                  </Button>
                  {employeeReport && employeeReport.length > 0 && (
                    <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
                      <DropdownToggle color="primary" className="btn button-export mt-2">
                        <i className="fas fa-file-export me-1" /> Export
                      </DropdownToggle>

                      <DropdownMenu>
                        <DropdownItem onClick={() => exportEmployeeToExcel(employeeReport, authDetails?.unit_fullname, authDetails?.unit_address, "Extra Hours Report")}>
                          <i className="fas fa-file-excel me-2 text-success" /> Export to Excel
                        </DropdownItem>

                        <DropdownItem onClick={() => exportEmployeeToPDF(employeeReport, authDetails?.unit_fullname, authDetails?.unit_address, "Extra Hours Report", activeColumns)}>
                          <i className="fas fa-file-pdf me-2 text-danger" /> Export to PDF
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  )}  
                </Col>
              </Row>
            </form>
          </CardBody>
        </Card>
        <Card>
          <CardBody>
            <TableContainer
              columns={activeColumns}
              data={employeeReport}
              isGlobalFilter={true}
              customPageSize={10}
              tableSorter={true}
            />
          </CardBody>
        </Card>

      </Container>
    </div>
  );
};

export default AttendanceReportOTHours;
